// API configuration constants
export const API_BASE_URL = process.env.REACT_APP_ENV === 'development' ? "http://localhost:5001" : "https://stg-api.raahglobalpak.kr";
// export const API_BASE_URL = "http://localhost:5001";

// API endpoints
export const ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: "/api/auth/login",
    REGISTER: "/api/auth/register",
    FORGOT_PASSWORD: "/api/auth/forgot-password",
    RESET_PASSWORD: "/api/auth/reset-password",
    VERIFY_EMAIL: "/api/auth/verify-email/:token",
    RESEND_EMAIL: "/api/auth/resend-email",
    UPDATE_PROFILE: "/api/auth/update-profile",
    ME: "/api/auth/profile",
    REFRESH_TOKEN: "/api/auth/refresh-token",
    LOGOUT: "/api/auth/logout",
    DELETE: "/api/auth/delete-account",
    CHANGE_PASSWORD: "/api/auth/change-password",
  },
  // University endpoints
  UNIVERSITIES: {
    POPULAR_UNIVERSITIES: "/api/universities/popular",
    GET_ALL_UNIVERSITIES: "/api/universities",
    GET_ALL: "/api/universities",
    DETAILS: (id: string) => `/api/universities/${id}`,
    PROGRAMS: (id: string) => `/api/universities/${id}/courses`,
    CREATE: "/api/universities",
    UPDATE: (id: string) => `/api/universities/${id}`,
    DELETE: (id: string) => `/api/universities/${id}`,
  },
  // Course endpoints
  COURSES: {
    GET_ALL_COURSES: "/api/courses",
    POPULAR_COURSES: "/api/courses/popular",
    DETAILS: (id: string) => `/api/courses/${id}`,
    CREATE: "/api/courses",
    UPDATE: (id: string) => `/api/courses/${id}`,
    DELETE: (id: string) => `/api/courses/${id}`,
  },
  // Users endpoints
  USERS: {
    PROFILE: "/api/users/profile",
    UPDATE_PROFILE: "/api/users/profile",
    STATS: "/api/users/stats",
    WISHLIST: "/api/users/wishlist",
    ADD_TO_WISHLIST: (courseId: string) => `/api/users/wishlist/${courseId}`,
    REMOVE_FROM_WISHLIST: (courseId: string) =>
      `/api/users/wishlist/${courseId}`,
  },
  // Application endpoints
  APPLICATIONS: {
    LIST: "/api/applications",
    CREATE: "/api/applications",
    DETAILS: (id: string) => `/api/applications/${id}`,
    UPDATE: (id: string) => `/api/applications/${id}`,
    DELETE: (id: string) => `/api/applications/${id}`,
    SUBMIT: (id: string) => `/api/applications/${id}/submit`,
    REQUIRED_DOCS: (courseId: string) => `/api/applications/required-documents/${courseId}`,
    DOCUMENTS: (id: string) => `/api/applications/${id}/documents`,
    UPLOAD_DOCS: (id: string) => `/api/applications/${id}/documents`,
    PAYMENT: (id: string) => `/api/applications/${id}/payment`,
    VALIDATE: (id: string) => `/api/applications/${id}/validate`,
  },
  // Documents endpoints
  DOCUMENTS: {
    UPLOAD: "/api/documents/upload",
    LIST: "/api/documents",
    DELETE: (id: string) => `/api/documents/${id}`,
  },
  // Admin endpoints
  ADMIN: {
    STATS: "/api/admin/stats",
    USERS: "/api/admin/users",
    USER_DETAILS: (id: string) => `/api/admin/users/${id}`,
    APPLICATIONS: "/api/admin/applications",
    APPLICATION_DELETE: (id: string) => `/api/admin/applications/${id}`,
    APPLICATION_STATUS: (id: string) => `/api/admin/applications/${id}/status`,
    VERIFY_DOCUMENT: (id: string) => `/api/admin/documents/${id}/verify`,
    UPLOAD_UNIVERSITY_IMAGE: (id: string) => `/api/admin/universities/${id}/upload-image`,
  },
};

// Request methods
export enum RequestMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

// API error codes and messages
export enum ApiErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  FORBIDDEN = "FORBIDDEN",
  NOT_FOUND = "NOT_FOUND",
  VALIDATION_ERROR = "VALIDATION_ERROR",
  SERVER_ERROR = "SERVER_ERROR",
}

// Response types
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: {
    code: string;
    message: string;
    details?: any;
  };
}
